import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { SegmentTrackEvent } from '@ninety/platform/models/analytics/segment/segment-track-event.enum';
import { SegmentActions } from '@ninety/platform/state/app-global/analytics/segment/segment.actions';

import { MeetingSchedulingActions } from '../meetings.actions';

@Injectable()
export class MeetingAnalyticsEffects {
  private readonly actions$ = inject(Actions);

  /**
   * Hooks the success action, not `addMeetingSchedule`. The request action fires the moment the
   * dialog is submitted, so a schedule the API rejected was still counted as created; the success
   * action is dispatched once per persisted schedule. It also carries the server's copy of the
   * schedule, which is where `teamId` now comes from — the store selector it replaced could be read
   * after a reducer had already moved on.
   *
   * No entityId/entityType: the POST response is typed `AddMeetingScheduleModel`, which has no _id,
   * so the event cannot name the schedule it created. Declaring an entityType with no id would
   * imply an entity the payload never identifies (same call as vision_pdf_printed).
   */
  trackMeetingScheduled$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeetingSchedulingActions.addMeetingScheduleSuccess),
      map(({ schedule }) =>
        SegmentActions.track({
          event: SegmentTrackEvent.MEETING_SCHEDULE_CREATED,
          params: {
            teamId: schedule.teamId,
            agendaId: schedule.agendaId,
            cadence: schedule.cadence,
            meetingType: schedule.meetingType,
          },
        })
      )
    )
  );
}
